export default __webpack_public_path__ + "assets/fd011e8e12d33c6b10e540b324f81bf9.png";